import React from 'react';
import { usePress } from '@react-aria/interactions';
import { CalendarIcon } from '@gwc/icons';
import { Leads } from '../slots';
import styles from './styles.module.css';
export function CalendarButton(props) {
    const { pressProps } = usePress(props);
    return (React.createElement(Leads.Icon, { ...pressProps, color: undefined, className: styles.calendarButton, 
        // важно что -1, позволяет фокусить стрелками,
        // но при этом избегать начального фокуса при клике по полю,
        // а также фокуса на таб
        tabIndex: -1 },
        React.createElement(CalendarIcon, null)));
}
